"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ProjectInfoChip = _interopRequireDefault(require("./ProjectInfoChip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _ProjectInfoChip.default;
exports.default = _default;